import { api } from "../index";
import { $config } from "../../conf";
import $store from "../../store";
import { $cookies } from "../../plugins/cookie";
import store from "../../store";
import { jsonp } from "vue-jsonp";

export let memberAPI = {
  /**
   * 通过openId 获取token
   * @param openId
   * @param unionId
   * @returns {*}
   */
  onMemberGetTokenByOpenId({ openId, unionId }) {
    return api.request("/member/GetTokenByOpenId", {
      openId,
      unionId,
    });
  },

  /**
   * 微信授权根据code获取token
   * @param code 微信授权拿到的excode
   * @returns {*}
   */
  onMemberVerifyTokenGetbycode({ code }) {
    return api.request("/api/member/verify/token/getbycode", {
      code,
    });
  },

  /**
   * 登录
   * @param unique 唯一标识
   * @param token 第三方登录传 token，token时不需要密码或是动态验证码
   * @param password 密码（md5加密转大写）
   * @param loginType 唯一标识字段
   * @param verify 第三方授权编码
   * @param url 第三方授权编码
   * @returns {*}
   */
  onMemberLogin({
    unique,
    token,
    password,
    loginType,
    verify,
    url = window.location.href,
  }) {
    return api.request("/member/login", {
      tenantId: $config.tenantId,
      schemaId: $config.schemaId,
      memberFormId: $config.memberFormId,
      unique,
      token,
      password,
      loginType,
      verify,
      url,
      globalUserId: $store.state.userInfo.globalUserId,
    });
  },

  /**
   * 向指定的手机或邮件发送验证码
   * @param action 验证码的功能类型(login登录 register注册 resetpassword重置密码 unbind_mobile解绑手机 bind_mobile绑定手机 all不区分场景)
   * @param unique 唯一字段值(邮箱或手机号码)
   * @returns {*}
   */
  onMemberVerifyCodeSend({ action, unique }) {
    return api.request("/api/member/verify/code/send", {
      tenantId: $config.tenantId,
      registerFormId: $config.memberFormId,
      action,
      unique,
    });
  },

  /**
   * 验证手机号/邮箱是否是当前用户
   * @param unique
   * @param checkCode
   * @param action
   * @returns {*}
   */
  onMemberVerifyTokenGet({ unique, checkCode, action }) {
    return api.request("/api/member/verify/token/get", {
      tenantId: $config.tenantId,
      formId: $config.memberFormId,
      unique,
      checkCode,
      action,
    });
  },
  checkRegister() {
    return api.request(
      "/partner/onlineSeminar/checkRegister",
      {
        tenantId: $config.tenantId,
        seminarId: $config.onlineSeminarId,
        globalUserId: $cookies.globalUserId(),
        token: $store.state["userInfo"]["token"].smarketToken,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }
    );
  },
  submitResponseForm(params) {
    return api.request(
      "/partner/onlineSeminar/addActionResponseRecord",
      params,
      {
        baseURL: $config.api.gateway.project,
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
          token: params.sess,
        },
      }
    );
  },
  //注销
  logout() {
    return jsonp(
      `https://oauth-login.cloud.huawei.com/connect/v2/logout?response_type=token&next=${encodeURIComponent(
        `https://api-eventsapp-project.smarket.net.cn/external/hw/codetotoken?url=logout&sess=${$store.state["userInfo"]["token"].smarketToken}`
      )}&access_token=${encodeURIComponent(
        $store.state["userInfo"]["token"].access_token
      )}`
    );
  },
  onMemberContactsInfoGet() {
    return api.request("/api/member/contacts/info/get", {
      isTemplate: 1,
      sess: $store.state.userInfo.session,
    });
  },
  onMemberContactsInfoUpdate({ formData }) {
    return api.request("/member/UpdateIdentityInfo", {
      formData,
      memberFormId: $config.memberFormId,
      schemaId: $config.schemaId,
      tenantId: $config.tenantId,
      sess: $store.state.userInfo.session,
    });
  },
  checkUnique(param) {
    return api.request(
      "/partner/onlineSeminar/checkUnique",
      {
        tenantId: $config.tenantId,
        seminarId: $config.seminarId,
        globalUserId: $cookies.globalUserId(),
        sess: $store.state["userInfo"]["token"].smarketToken,
        ...param,
      },
      {
        baseURL: $config.api.gateway.project,
      }
    );
  },
  sendVerificationCode(param) {
    const url =
      param.type === 1
        ? "/member/sendVerificationCodeToMail"
        : "/member/sendVerificationCode";
    const smsSign = param.type === 1 ? "" : "华为伙伴暨开发者大会2022";
    const action = param.type !== 1 ? "" : "register_cn";
    return api.request(
      url,
      {
        tenantId: $config.tenantId,
        seminarId: $config.seminarId,
        memberSchemaId: $config.schemaId,
        globalUserId: $cookies.globalUserId(),
        sess: $store.state["userInfo"]["token"].smarketToken,
        smsSign,
        action,
        ...param,
      },
      {
        baseURL: $config.api.gateway.general,
      }
    );
  },
  updateUnique(param) {
    return api.request(
      "/partner/onlineSeminar/updateUnique",
      {
        tenantId: $config.tenantId,
        seminarId: $config.seminarId,
        memberSchemaId: $config.schemaId,
        action: "register_cn",
        globalUserId: $cookies.globalUserId(),
        sess: $store.state["userInfo"]["token"].smarketToken,
        ...param,
      },
      {
        baseURL: $config.api.gateway.project,
      }
    );
  },
  /*** 获取我的互动头像 * @returns {*} */
  getMyAvatar() {
    return api.request(
      "/interaction/api/figure/get",
      {
        campaign: "partner2022",
        tenantId: $config.tenantId,
        sess: $store.state["userInfo"]["token"].smarketToken,
        includeHead: 1,
      },
      {
        baseURL: $config.api.gateway.project,
        headers: { "Content-Type": "application/json; charset=UTF-8" },
      }
    );
  },
};
